import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllAtmedFeedBackPharmacy,
} from '../../../store/actions';
import FeedBack from './Feedback';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  allEquipmentFeedback: vendorEquipmenReducer.allEquipmentFeedback,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllAtmedFeedBackPharmacy,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(FeedBack);
